import type { CourseCategory } from './categories.js';

export type SubCategory = {
  readonly slug: string;
  readonly label: string;
};

/**
 * Per docs/04_DATA_MODEL.md — locked sub-category list.
 * Tenants can rename labels via tenants.sub_category_labels keyed by `${category}.${slug}`.
 */
export const SUB_CATEGORIES = {
  vocational: [
    { slug: 'cert_iii', label: 'Certificate III' },
    { slug: 'cert_iv', label: 'Certificate IV' },
    { slug: 'diploma', label: 'Diploma / Advanced Diploma' },
  ],
  higher_education: [
    { slug: 'graduate_diploma_pathway', label: 'Graduate Diploma (pathway to Bachelors)' },
    { slug: 'bachelors', label: 'Bachelors' },
    { slug: 'bachelors_honours', label: 'Bachelors (Honours)' },
    { slug: 'masters', label: 'Masters' },
  ],
  research: [
    { slug: 'master_by_research', label: 'Master by Research' },
    { slug: 'phd', label: 'PhD' },
  ],
  trade: [
    { slug: 'cert_iii', label: 'Certificate III' },
    { slug: 'cert_iv', label: 'Certificate IV' },
  ],
} as const satisfies Record<CourseCategory, readonly SubCategory[]>;

/** Helper: tenant-override key for a sub-category label. */
export function subCategoryOverrideKey(category: CourseCategory, slug: string): string {
  return `${category}.${slug}`;
}
